<template>
  <div v-if="!!title">
    <div class="head" :style="titleStyle">
      <q-icon
        name="svg:back_icon"
        style="stroke: #000000;"
        size="21px"
        @click="$emit('back')"
      />
      <p class="head-title">{{ title | filterTag }}</p>
    </div>
    <div v-if="isGradient" class="reverseHead" :style="reverseTitleStyle">
      <q-icon
        name="svg:back_icon"
        style="stroke: #ffffff;"
        size="21px"
        @click="$emit('back')"
      />
      <p class="head-title">{{ title | filterTag }}</p>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    filterTag(value) {
      if (!value) return '';
      const reg = /<br\/?>/g;
      return value.replace(reg, '');
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    isGradient: {
      type: Boolean,
      default: false,
    },
    gradient: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  computed: {
    titleStyle() {
      if (!this.isGradient) {
        return { opacity: 1 };
      }
      return { opacity: this.gradient };
    },
    reverseTitleStyle() {
      return { opacity: 1 - this.gradient };
    },
  },
};
</script>

<style scoped lang="scss">
.head,
.reverseHead {
  position: absolute;
  top: 0;
  width: 100%;
  background: #fff;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  z-index: 10;
  .head-title {
    color: $black;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    padding-left: 27px;
  }
}
.reverseHead {
  background: transparent;
  color: #fff;
  .head-title {
    color: #fff;
  }
}
</style>
